import { gql } from 'graphql.macro';
import { oauthAppFieldsFragment } from 'apollo/fragments/oauth-app';

export const getOAuthAppsTemplate = gql`
    query oauthApps {
        oauthApps {
            ...oauthAppFields
        }
    }
    ${oauthAppFieldsFragment}
`;

export const clinicsForOAuthAppsTemplate = gql`
    query parentClinics($filters: ClinicsFilters!, $limit: Int!, $offset: Int!) {
        parentClinics(filters: $filters, limit: $limit, offset: $offset, orderBy: "name", orderDirection: asc) {
            _id
            name
        }
    }
`;
